export class ThemeEntity {

  private _code: string;
  private _name: string;
  private _primary: string;
  private _secondary: string;
  private _surface: string;
  private _surfaceVariant: string;
  private _text: string;
  private _textVariant: string;

  constructor(props: ThemeCreateProps) {
    this._name = props.name;
    this._code = props.code;
    this._primary = props.primary;
    this._secondary = props.secondary;
    this._surface = props.surface;
    this._surfaceVariant = props.surfaceVariant;
    this._text = props.text;
    this._textVariant = props.textVariant;
  }

  static create(props: ThemeCreateProps): ThemeEntity {
    return new ThemeEntity(props);
  }

  get code(): string {
    return this._code;
  }

  get name(): string {
    return this._name;
  }

  get primary(): string {
    return this._primary;
  }

  get secondary(): string {
    return this._secondary;
  }

  get surface(): string {
    return this._surface;
  }

  get surfaceVariant(): string {
    return this._surfaceVariant;
  }

  get text(): string {
    return this._text;
  }

  get textVariant(): string {
    return this._textVariant;
  }

}


export interface ThemeCreateProps {
  name: string;
  code: string;
  primary: string;
  secondary: string;
  surface: string;
  surfaceVariant: string;
  text: string;
  textVariant: string;
}
